import { createFileRoute } from '@tanstack/react-router';
import { PickListPage } from '@/features/inventory/PickListPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/pick-lists_/$id')({
  component: Page,
});
function Page() {
  const { id } = Route.useParams();
  return <PickListPage key={id} id={id} />;
}
